/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
// /* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
import { useOnClickOutside } from "../../../../../../CommonMethods/OutsideClick";
import { useCallback } from "react";
import Debounce from "../../../../../../CommonMethods/Debounce";
import { useDispatch ,useSelector} from "react-redux";
import moment from "moment"
import { convertDatesToEpochUTC } from "../../../../../../CommonMethods/ConvertFilterDatetoEpochUtcFormat";
import {  searchReducerr, selectAllRows, toggleRowSelection,handleTotalUsers } from "../../../../../../redux/wellnessFilterSlice";
import { BeatLoader } from "react-spinners";
import { dataService } from "../../../../../../services/data.services";
import { useSearchParams } from "react-router-dom";

export default function PatientDropdownAlertWithSearch({
    label,
    id,
    placeholder,
    disabled,
    emptyField,
    index, 
    value,
    filterValues,
    setFilterValues,
    isSelectAllChecked,
    setIsSelectAllChecked,
    suggestions,
    setSuggestions,
    isSearchedSelectAllChecked,
    setIsSearchedSelectAllChecked

}
) {
    const ref = useRef();
    const [searchParams,setSearchParams] = useSearchParams()
    const dispatch = useDispatch()
    const [displayEmptyMsg,setDisplayEmptyMsg] = useState('')
    const [isOpen,setisOpen] = useState(false)
    const [items, setItems] = useState([]);
    const [searchLoading,setSearchLoading] = useState(false)
    const [page, setPage] = useState(1);
    const [error,setError] = useState(false)
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const selectedUsers=useSelector(state=>state?.filterSelect?.selectedUsers)
    const selectedUserIds = useSelector(state=>state?.filterSelect?.selectedUsers?.selectedArr)
    const unSelectedUserIds = useSelector(state=>state?.filterSelect?.selectedUsers?.unselectedArr)
    const isCheckedAll = useSelector(state=>state?.filterSelect?.selectedUsers?.isCheckedAll)
    const totalUsers = useSelector(state=>state.filterSelect.selectedUsers.totalUsers)

    const handleChange=(val)=>{
        fetchData(encodeURIComponent(val.trim()),'initial')
    }

    function handleIsCheckedAll(event){
        suggestions?.trim()===''?setIsSelectAllChecked(event.target.checked):setIsSearchedSelectAllChecked(event.target.checked)
        dispatch(selectAllRows([event.target.checked,items,suggestions]))
    }
    

    useOnClickOutside(ref, () => {
        setisOpen(false);
    });

    const fetchData = async(search,initial) => {
        if (!hasMore) return;
        setIsLoading(true);
        try{
            let res
            if(search===undefined||search===''){
                if(search===''){
                    setHasMore(true)
                    setPage(1)
                    setItems([])
                }
                res = await dataService.GetAPI(`patients/alerts-dropdown?filter_type=patient&start_date=${moment(filterValues?.start_date).format('YYYY-MM-DD')}&end_date=${moment(filterValues?.end_date).format('YYYY-MM-DD')}&dropdown_type=alerts&page_number=${page}&limit=20`)
                if(res.data.status===200){
                    setError(false)
                    setSearchLoading(false)
                    if(totalUsers!==res?.data?.data?.total_count){

                        dispatch(handleTotalUsers([res?.data?.data?.total_count]))
                    }
                    if (res?.data?.data?.data?.length === 0) {
                        setIsLoading(false)
                        setHasMore(false); // No more data available
                    }
                    setItems(prevItems=>[...prevItems,...res?.data?.data?.data])
                    setPage(prevPage => prevPage + 1);
                    setIsLoading(false);
                }
            }else{
                if(initial!==undefined&&initial==='initial'){
                    setHasMore(true)
                    setPage(1)
                    setItems([])
                }

                res = await dataService.GetAPI(`patients/alerts-dropdown?filter_type=patient&start_date=${moment(filterValues?.start_date).format('YYYY-MM-DD')}&end_date=${moment(filterValues?.end_date).format('YYYY-MM-DD')}&dropdown_type=alerts&page_number=${initial!==undefined&&initial==='initial'?'1':page}&search=${encodeURIComponent(search)}`)
                if(res.data.status===200){
                    setError(false)
                    setSearchLoading(false)
                 
                    setIsLoading(false)
                    setHasMore(false); // No more data available
                    
                
                    initial!==undefined&&initial==='initial'?setItems(res?.data?.data?.data):setItems(prevItems=>[...prevItems,...res?.data?.data?.data])
                    initial!==undefined&&initial==='initial'?setPage(2):setPage(prevPage => prevPage + 1);
                    setIsLoading(false);
                }
            }
            
        }catch(error){
            setIsLoading(false);
            setError(true)
        }
       
    };
    useEffect(() => {
        items?.length===0&&fetchData();
        
    }, []);
    const handleScroll = () => {
        
        if (((document.getElementById('device_scrollarea').scrollTop+document.getElementById('device_scrollarea')?.clientHeight) !== (document.getElementById('device_scrollarea')?.scrollHeight)) || isLoading) {
            return;
        }
        suggestions.trim()===''?fetchData():fetchData(encodeURIComponent(suggestions?.trim()));
    };


    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        []
    );

    useEffect(() => { 
        isOpen&&suggestions!==''&&optimizedFn('')
        isOpen&&setSuggestions('')
        return () => {
        };
    }, [isOpen]);

    useEffect(() => {
        if(items!==undefined){
            if(items?.length===0)  {
                setDisplayEmptyMsg('No results found.')
                return
                
            } 
            let searchedIds = items.map(item=>item?._id)
            if(isSelectAllChecked&&!searchedIds.some(item=>unSelectedUserIds.includes(item))||(!isSelectAllChecked&&searchedIds.every(item=>selectedUserIds.includes(item)))){
                setIsSearchedSelectAllChecked(true)
            }else{
                setIsSearchedSelectAllChecked(false)
            }
            setDisplayEmptyMsg('')
            dispatch(searchReducerr([items,isSelectAllChecked,isSearchedSelectAllChecked,suggestions?.trim()===''?'complete_list':'searched_list',searchParams.get('selected_patient_ids')]))
        } 
        
    },[items])
    
    const handleToggleChange = () =>{

    }
    
    return (
        <>
            <div className='relative' ref={ref}>
                <label htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                <button data-testid={'patient-dropdown'}  onClick={() => {setisOpen(!isOpen)}} className={`border 'border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal 
                             text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`} disabled={disabled}>
                    <p id= {id} className={`${(value === "" || value === undefined || value === true)?'text-[#52555D] ':'text-[#000B17] '}text-start text-sm more-lines`}>{(value === "" || value === undefined || value === true)
                        ? placeholder
                        : value}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen?"transform rotate-180" : ""}`}/>
                </button>
                <ul className={`py-4 pr-1 xl:pl-4 pl-3.5 rounded-lg bg-white z-[9] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpen ? "" : "hidden"}`}>
                    <li>
                        <ul>
                            <li>
                                <div className="relative pr-3">
                                    <label htmlFor=""></label>
                                    <input 
                                        type="text" 
                                        autoComplete={"off"}
                                        id="search-value"
                                        placeholder="Search by patient name"
                                        className="border border-[#C5C9DA] rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none placeholder:text-[11px]" 
                                        onChange={e=>{setSuggestions(e.target.value);optimizedFn(e.target.value);setSearchLoading(true)}}
                                        value={suggestions}/>
                                    <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3"/>
                                </div>
                            </li>
                            {(!isLoading&&(displayEmptyMsg==="" &&!(((error)||(items===undefined&&error)))&&items?.length!==0))&&!searchLoading?<li className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1 pr-4'>
                                <div className="relative checkbox custom-checkBoxBlue1">
                                    <input type="checkbox" id='id1' checked={isCheckedAll||(suggestions?.trim()===''&&isSelectAllChecked&&(unSelectedUserIds.length===0))||(suggestions?.trim()!==''&&isSearchedSelectAllChecked&&unSelectedUserIds.length===0)} onChange={(e)=>handleIsCheckedAll(e)} className='prevent-click' />
                                    <label htmlFor='id1' data-testid="select-all" id='select-all' className={`text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4`}>Select All</label>
                                </div>
                                <button data-testid={'clear_all'} onClick={()=>{dispatch(selectAllRows([false,items,suggestions])),handleIsCheckedAll({"target":{"checked":false}})}} type='button' className={(suggestions?.trim()===''&&((!isCheckedAll&&unSelectedUserIds.length===0&&selectedUserIds.length===0)||(!isSelectAllChecked&&selectedUserIds.length===0))||(suggestions?.trim()===''&&((items.every(item => unSelectedUserIds.includes(item._id))))&&totalUsers===items?.length)||(suggestions?.trim()!==''&&(items.every(item=>unSelectedUserIds.includes(item?._id)))))?'hidden':`text-xs font-semibold text-[#008586]`}>
                                    Clear All
                                </button>
                            </li>:!isLoading&&items?.length===0&&<p className="mt-2 text-center">{displayEmptyMsg}</p>}
                        </ul>
                        {((isLoading&&items?.length===0)||searchLoading)? <div className=' h-[30px] relative   px-4 xl rounded-lg mt-3 '>
                            <div className='flex justify-center items-center mt-[90px]'>
                                                       
                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  mt-[-45px] spin-animation"></div>
                                                       
                                                        
                            </div>
                        </div>:<ul>
                            <li>
                                <ul id={"device_scrollarea"}  className={`max-h-[calc(100vh-550px)] overflow-auto scrollbar_gray pr-3`} onScroll={handleScroll}>
                                    {
                                        items?.map((item,i)=>(
                                            <li key={i} className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1'>
                                                <div className="relative checkbox custom-checkBoxBlue1 flex items-center">
                                                    {/* checked={selectedUsers?.checkedArr[curIndex]?.includes(item?.user_id)?true:false}  */}
                                                    <input type="checkbox" id={item?._id} onChange={(event)=>{handleToggleChange(),dispatch(toggleRowSelection([item?._id,items,suggestions?.trim()===''?isSelectAllChecked:isSearchedSelectAllChecked,suggestions?.trim()===''?'complete_list':'searched_list',event.target.checked,isSelectAllChecked]))}} checked={suggestions?.trim()===''?((isSelectAllChecked&&!(unSelectedUserIds?.includes(item?._id)))||selectedUserIds?.includes(item?._id)||isCheckedAll):((isSearchedSelectAllChecked&&!(unSelectedUserIds?.includes(item?._id)))||(isSelectAllChecked&&!(unSelectedUserIds?.includes(item?._id)))||(selectedUserIds?.includes(item?._id))||(isCheckedAll))} className='prevent-click' />
                                                    <label data-testid={`patient-${i}`} id={`patient-${i}`} title={`${item?.details?.last_name}, ${item?.details?.first_name} ${item?.details?.middle_name}`} htmlFor={item?._id} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines">{item?.details?.last_name}, {item?.details?.first_name} {item?.details?.middle_name}</label>
                                                </div>
                                            </li>
                                        ))
                                    }
                                </ul>
                                {items.length>0&&isLoading&&<div className="flex justify-center"><BeatLoader color='#972E4C'/></div>}
                            </li>
                        </ul>}
                    </li>
             
                </ul>             
            </div>
        </>
    )
}
